export default "__VITE_ASSET__f9ede956__"